import React from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './DownloadHero.module.scss';

const DownloadHero = ({ downloadCenterHero }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const title = downloadCenterHero?.title || '';
  const text = downloadCenterHero?.text || '';

  // 检查图片字段是否有有效数据
  const hasValidImage =
    downloadCenterHero?.image?.fields &&
    (downloadCenterHero.image.fields.desktopImage?.value?.src ||
      downloadCenterHero.image.fields.tabletImage?.value?.src ||
      downloadCenterHero.image.fields.mobileImage?.value?.src);

  return (
    <div className={styles.wrapper}>
      {hasValidImage ? (
        <>
          <div className={styles.image}>
            <Image
              alt="Download center hero"
              field={downloadCenterHero.image.fields.desktopImage}
            />
          </div>
          <div className={styles.mobileImage}>
            <Image
              alt="Download center hero mobile"
              field={downloadCenterHero.image.fields.mobileImage}
            />
          </div>
        </>
      ) : (
        // 如果没有图片，显示一个背景色或默认样式
        <div className={styles.noImageFallback}>
          <p style={{ color: 'white', textAlign: 'center', padding: '20px' }}>
            No hero image available
          </p>
        </div>
      )}
      <div>
        <h1 className={styles.title} data-aos="fade-up" data-aos-offset="100">
          {title}
        </h1>
        <div
          className={styles.text}
          data-aos="fade-up"
          data-aos-offset="150"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
    </div>
  );
};

export default DownloadHero;
